<a href="/" class="treeslo-branding-link">
  <img
    [src]="logoSrc"
    [attr.width]="logoWidth"
    alt="Treeslo logo"
    class="treeslo-branding-logo align-middle"
    [class.treeslo-branding-logo--mini]="useMiniLogo"
    [class.treeslo-branding-logo--spin]="miniLogoSpinActive"
    [class.treeslo-branding-logo--mobile-sidebar]="isMobileSidebarLarge"
    [class.treeslo-branding-logo--sidebar-desktop]="isDesktopSidebarLarge"
    [class.treeslo-branding-logo--auth]="isAuthLayout"
    (animationend)="onMiniLogoAnimationEnd($event)"
  />
</a>
